import { create } from 'zustand';
import { repository } from './app-loader';

const useAppStore = create((set, get) => ({
  init: false,
  setInit: () => set({ init: true }),
  app: '',
  setApp: (payload) => set({ app: payload }),
  globalAction: {},
  setGlobalAction: (payload) => set({ globalAction: payload }),
  user: null,
  setUser: (payload) => set({ user: payload }),
  defaultPlate: null,
  setDefaultPlate: (payload) => set({ defaultPlate: payload }),
  defaultReceipt: null,
  setDefaultReceipt: (payload) => set({ defaultReceipt: payload }),
  fetchUser: async (handleError) => {
    const { error, data } = await repository.fetchUserInfo();
    if (error) return handleError(error);
    set({
      user: data,
      init: true,
    });
  },
}));

export default useAppStore;
